// components/RenderFunctional/variants/AddFunctional.jsx
import React from 'react'
import { Row, Col } from 'react-bootstrap'

const AddFunctional = ({ buttonText, handleShow }) => {
    return (
        <Row>
            <Col md={12}>
                <div className="disk">
                    <button className="disk__upload-label" onClick={handleShow}>
                        {buttonText || 'Добавить'}
                    </button>
                </div>
            </Col>
        </Row>
    )
}

export default AddFunctional
